import React from 'react';
import { Grid } from '@mui/material';
import Form from 'pages/service-account-creation/components/Form';
import FormCard from 'pages/service-account-creation/components/form-card';
import { useRecoilState } from 'recoil';
import { OrderPayload, SQLServer } from 'pages/service-account-creation/store';
import { ACTIVE_DIRECTORY_ACCOUNT_TYPE } from 'pages/service-account-creation/constant';

const ProjectForm = () => {
    const [isSQLServer] = useRecoilState(SQLServer);
    const [order] = useRecoilState(OrderPayload);

    return (
        <Grid>
            <Grid item md={8} borderRadius={1.5} gap={1}>
                <FormCard title="Application" gap={0} margin={2}>
                    <Grid item container spacing={2} sx={{ mt: 2, mb: 2 }}>
                        <Grid item md={6} sm={6} xs={12}>
                            <Grid container direction="column" spacing={4}>
                                <Grid item>
                                    <Form.ApplicationService />
                                </Grid>
                                <Grid item>
                                    <Form.ApplicationName />
                                </Grid>
                                <Grid item>
                                    <Form.Environments />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={6} sm={6} xs={12}>
                            <Grid container direction="column" spacing={4}>
                                <Grid item>
                                    <Form.Sector />
                                </Grid>
                                <Grid item>
                                    <Form.ApplicationShortName />
                                </Grid>
                                <Grid item>
                                    <Form.ApplicationOwner />
                                </Grid>
                                {isSQLServer && (
                                    <Grid item>
                                        <Form.SQLServerName />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </FormCard>
            </Grid>
            <Grid item md={8} borderRadius={1.5} gap={1} mt={2}>
                <FormCard title="Resource" gap={0} margin={2}>
                    <Grid item container spacing={1} sx={{ mt: 2, mb: 2 }}>
                        <Grid item md={6} sm={6} xs={12}>
                            <Grid container direction="column" spacing={2}>
                                <Grid item>
                                    <Form.AccountType />
                                </Grid>
                                <Grid item>
                                    <Form.ServiceAccName />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={6} sm={6} xs={12}>
                            <Grid container direction="column" spacing={2}>
                                <Grid item>
                                    <Form.AccountOwner />
                                </Grid>
                                {order?.accountType === ACTIVE_DIRECTORY_ACCOUNT_TYPE && (
                                    <>
                                        <Grid item>
                                            <Form.MyPamSafeDropdown />
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </FormCard>
            </Grid>
        </Grid>
    );
};

export default ProjectForm;
